import type { SvgIconProps } from '@mui/material/SvgIcon';
import { forwardRef } from 'react';
import { type IconPickerType, iconPickerMap } from './icons';

export interface IconPickerIconProps extends SvgIconProps {
  icon: IconPickerType | undefined | null;
}

export const IconPickerIcon = forwardRef<SVGSVGElement, IconPickerIconProps>(
  ({ icon, ...props }, ref) => {
    const Icon = iconPickerMap.get(icon!);

    if (!Icon) return null;
    return <Icon ref={ref} {...props} />;
  },
);
